import { AllInclusiveIcon } from './AllInclusiveIcon';

/**
 * author: Google
 * id 5596E6E7-916E-4870-9346-5D46BC86C0D5
 * name all-inclusive
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/all-inclusive.svg
 * tags
 */
export const ForeverIcon = AllInclusiveIcon;
export default ForeverIcon